import { Link as RouterLink } from 'react-router-dom';

import { experimentalStyled as styled } from '@material-ui/core/styles';
import { Card, Stack, Link, Container, Typography } from '@material-ui/core';
import AuthLayout from '../../layouts/AuthLayout';
import Page from '../../components/Page';
import { MHidden } from '../../components/@material-extend';
import EnterpriseSettings from '../../components/configs/EnterpriseSettings';
import EnterpriseSettingsList from '../../components/configs/EnterpriseSettingsList';

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
    minHeight: '100%',
    paddingTop: theme.spacing(10),
    paddingBottom: theme.spacing(10)
  }
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 350,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(4, 2, 2, 2)
}));

const ContentStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  padding: theme.spacing(2, 0)
}));

export default function ConfigEnterprise() {
  return (
    <RootStyle title="Settings | ZIMTA">
      <MHidden width="mdDown">
        <SectionStyle>
          <EnterpriseSettings />
        </SectionStyle>
      </MHidden>

      <Container>
        <ContentStyle>
          <EnterpriseSettingsList />
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
